import { Plural } from "@lingui/react/macro";
import React from "react";
import { isPresent } from "./checks";
import { toUTCDate } from "./date";
import { formatGuests } from "./common-plurals";

const validVersion = <T extends { validFrom?: Date | string }>(
  version: T | undefined
): version is T & { validFrom: Date } =>
  isPresent(version) && isPresent(version.validFrom);

//WARNING: even if the graphql type says validFrom is a Date, actually is returned from gatsby as string :(
export const getCurrentVersionAt = <T extends { validFrom?: Date | string }>(
  versions: (T | undefined)[] | undefined,
  date: Date | string
): T | undefined => {
  const version = (versions || [])
    .filter(validVersion)
    .filter((x) => {
      return toUTCDate(x.validFrom).getTime() <= toUTCDate(date).getTime();
    })
    .sort(
      (a, b) =>
        toUTCDate(b.validFrom).getTime() - toUTCDate(a.validFrom).getTime()
    )[0];

  if (version) return version;
  if (versions) return versions[0]; //fallback to the first version

  return undefined;
};

export const getShipVersionFromKey = <T extends { _key?: string }>(
  versions: (T | undefined)[] | undefined,
  key: string
): T | undefined => {
  const version = (versions || []).find(findByVersionKey(key));

  if (version) return version;
  if (versions) return versions[0]; //fallback to the first version

  return undefined;
};

const findByVersionKey =
  <T extends { _key?: string } | undefined>(key: string) =>
  (version: T) =>
    version?._key == key;

export const renderShipPassenderCrew = (props) => {
  return (
    <React.Fragment>
      {formatGuests(props.passengerCount)} &bull;{" "}
      <Plural value={props.crewCount} one="# Crew" other="# Crew" />
    </React.Fragment>
  );
};
